import React from "react";
import AppBody from "../components/AppBody";
import { Link } from "react-router-dom";
import CartData from "./CartData";

const AuthCart = () => {
  return (
    <AppBody
      loading={false}
      content={
        <div className="middle-sidebar-left">
          <div className="card w-100 border-0  shadow-xs p-0 mb-4">
            <div className="card-header p-3 w-100 border-0 d-flex rounded-lg">
              <Link to={"/users"} className="d-inline-block mt-2">
                <i className="ti-arrow-left font-sm text-white"></i>
              </Link>
              <h4 className="font-xs text-white fw-600 ml-4 mb-0 mt-2">Cart</h4>
            </div>
            <div className="card-body  p-4 w-100 border-0 ">
                 <CartData/>
             </div>
          </div>
        </div>
      }
    />
  );
};

export default AuthCart;
